import React__default from 'react';

const Spacer = ({ className, width = 0, height = 0 }) => {
  return React__default.createElement("div", { style: { width, height }, className, "data-zds": true });
};

export { Spacer };
//# sourceMappingURL=Spacer.es.js.map
